import React from "react";

const StickySetScore = ({
  placar,
  positionHome,
  teamNames,
  scoutList = [],
}) => {
  // Conta tempos pedidos
  const countTimeouts = (side) => {
    if (!Array.isArray(scoutList)) return 0;
    if (side === "home") {
      return scoutList.filter(
        (j) =>
          typeof j.cod === "string" &&
          (j.cod.startsWith("*t") || j.cod.startsWith("*T"))
      ).length;
    } else {
      return scoutList.filter(
        (j) =>
          typeof j.cod === "string" &&
          (j.cod.startsWith("at") || j.cod.startsWith("aT"))
      ).length;
    }
  };
  const homeTimeouts = countTimeouts("home");
  const awayTimeouts = countTimeouts("away");

  return (
    <div className="flex items-center justify-center">
      <div className="inline-flex items-center rounded px-3 py-1 shadow-lg">
        {/* Tempo pedidos lado externo esquerdo */}
        {positionHome ? (
          <span className="text-[10px] text-gray-500 mr-1 min-w-[12px] text-center select-none">
            {homeTimeouts}
          </span>
        ) : (
          <span className="text-[10px] text-gray-500 mr-1 min-w-[12px] text-center select-none">
            {awayTimeouts}
          </span>
        )}
        {/* Placar coluna esquerda */}
        <div
          className={`h-[30px] w-[40px] flex items-center justify-center rounded-l-md ${
            positionHome ? "bg-blue-600" : "bg-red-600"
          } text-white text-xl shadow`}
        >
          {positionHome ? placar?.[0] ?? "-" : placar?.[1] ?? "-"}
        </div>
        {/* Separador */}
        <span className="mx-2 text-xl text-gray-700 font-bold">x</span>
        {/* Placar coluna direita */}
        <div
          className={`h-[30px] w-[40px] flex items-center justify-center rounded-r-md ${
            positionHome ? "bg-red-600" : "bg-blue-600"
          } text-white text-xl shadow`}
        >
          {positionHome ? placar?.[1] ?? "-" : placar?.[0] ?? "-"}
        </div>
        {/* Tempo pedidos lado externo direito */}
        {positionHome ? (
          <span className="text-[10px] text-gray-500 ml-1 min-w-[12px] text-center select-none">
            {awayTimeouts}
          </span>
        ) : (
          <span className="text-[10px] text-gray-500 ml-1 min-w-[12px] text-center select-none">
            {homeTimeouts}
          </span>
        )}
      </div>
    </div>
  );
};

export default StickySetScore;
